import React from 'react';
import { Col, Row } from 'reactstrap';
import { FormFieldHeader } from '../../../../../../../../../components/FormFieldHeader';
import { Control, Controller } from 'react-hook-form';
import {
  LocationOption,
  LocationSelect,
} from '../../../../../../../../../components/LocationSelect';
import { getSelectedOption } from '../../../../../../../Candidates/LocationInput';
import { LocationValue } from '../..';

interface PropTypes {
  control: Control<LocationValue>;
}

export function LocationFieldsInputRow(props: PropTypes) {
  return (
    <Row className='mb-3'>
      <Col sm={12}>
        <FormFieldHeader
          fieldName='Location'
          classNames='fw-semibold'
          isRequired={true}
        />
        <Controller
          control={props.control}
          name={'location'}
          rules={{ required: 'Location is required' }}
          render={({ field }) => (
            <LocationSelect
              selected={getSelectedOption(field.value)}
              placeholder={'Add an address, city... Or select an option'}
              onChange={(option: LocationOption) => {
                if (option == null) {
                  field.onChange(null);
                  return;
                }
                field.onChange({
                  name: option.label,
                  address: option.address,
                  city: option.city,
                  state: option.state,
                  country: option.country,
                  latitude: option.latitude,
                  longitude: option.longitude,
                });
              }}
              className='fs-5'
              isClearable={true}
            />
          )}
        />
      </Col>
    </Row>
  );
}
